export const formatCount = (count) => {
  if (count >= 1_000_000) {
    return `${Math.floor(count / 100_000) / 10}M`;
  } else if (count >= 10_000) {
    return `${Math.floor(count / 100) / 10}K`;
  } else {
    return count.toString();
  }
};